import script from "./SMSTemplates.vue?vue&type=script&lang=ts&setup=true"
export * from "./SMSTemplates.vue?vue&type=script&lang=ts&setup=true"

import "./SMSTemplates.vue?vue&type=style&index=0&id=4451324e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4451324e"]])

export default __exports__